import { get } from "./api";

const fetchGoogleDriveFolders = () => {
  return get("/api/v2/google/drive/activefolders", {}, true);
};

const fetchFolderFiles = (folderId) => {
  return get(`/api/v2/google/drive/files/${folderId}`, {}, false);
};

const fetchAuthUrl = () => {
  return get("/api/v2/google/auth/url", {}, false);
};

const checkGoogleDriveAuth = () => {
  return get("/api/v2/google/drive/checkauth");
};

export {
  checkGoogleDriveAuth,
  fetchAuthUrl,
  fetchGoogleDriveFolders,
  fetchFolderFiles,
};
